import { useState, useEffect, useCallback } from 'react';

const useMessages = (conversationId) => {
  const [messages, setMessages] = useState([]);

  const fetchMessages = useCallback(async () => {
    if (!conversationId) return; 

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/conversations/${conversationId}/messages`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch messages: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      
      if (data.success && data.data) {
        setMessages(data.data); 
      } else {
        setMessages([]);
      }
    } catch (error) {
      setMessages([]);
    }
  }, [conversationId]);

  useEffect(() => {
    fetchMessages();
  }, [conversationId]); 

  return [messages, setMessages];
};

export default useMessages;
